'use client';
/** @jsxImportSource @emotion/react */

import type { ListItemTextProps as MuiListItemTextProps } from '@mui/material/ListItemText';

import MuiListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';

interface ListItemTextProps extends MuiListItemTextProps {
  color?: MuiListItemTextProps['color'] | 'forceWhite';
}

/**
 * @deprecated Please use `List.ItemText` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export type { ListItemTextProps };
/**
 * @deprecated Please use `List.ItemText` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export const ListItemText: React.FC<ListItemTextProps> = ({
  color,
  ...props
}) => {
  const theme = useTheme();
  const resolvedColor =
    color === 'forceWhite' ? theme.palette.forceWhite.main : color;
  return (
    <MuiListItemText
      {...props}
      primaryTypographyProps={{
        ...props.primaryTypographyProps,
        color: resolvedColor,
      }}
    />
  );
};

ListItemText.displayName = 'ListItemText';
